import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function QualityRing({
  score,
  size = 48
}: {
  score: number;
  size?: number;
}) {
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - score / 100 * circumference;
  const color = score >= 80 ? 'text-emerald-500' : score >= 60 ? 'text-amber-500' : 'text-red-500';
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-6711" data-mp="20o7dg3kk39r9">
      <svg className="transform -rotate-90" style={{
      width: size,
      height: size
    }} data-id="element-6712" data-mp="2aetpxowz7k5q">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" className="text-gray-100" data-id="element-6713" data-mp="2fcboqmha4j00" />
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" strokeDasharray={circumference} initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className={color} strokeLinecap="round" data-id="element-6714" data-mp="2oeusr9wsx1nu" />
      </svg>
      <span className="absolute text-sm font-bold text-gray-900" data-id="element-6715" data-mp="3oz7z0shdjoiy">{score}%</span>
    </div>;
}
export function ProgressBar({
  value,
  color = 'bg-blue-500',
  label
}: {
  value: number;
  color?: string;
  label?: string;
}) {
  return <div data-id="element-6716" data-mp="3f8d5r45pnoo0">
      {label && <div className="flex justify-between text-xs mb-1" data-id="element-6717" data-mp="3f7bx16c63e9g">
          <span className="text-gray-600" data-id="element-6718" data-mp="gkg2j7m1e9vr">{label}</span>
          <span className="font-medium text-gray-700" data-id="element-6719" data-mp="gl8yrenddgzn">{value}%</span>
        </div>}
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-6720" data-mp="bqldrprkr4pt">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${value}%`
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className={`h-full rounded-full ${color}`} data-id="element-6721" data-mp="2611wbd5niegq" />
      </div>
    </div>;
}